import { NavLink } from 'react-router-dom';

const LINKS = [
  { to: '/admin', label: 'Communities', end: true },
  { to: '/admin/visitors', label: 'Visitor analytics' },
  { to: '/admin/usage', label: 'App analytics' },
  { to: '/admin/settings', label: 'Settings' },
];

export function AdminNav() {
  return (
    <div className="chip-row" role="tablist" aria-label="Super Admin">
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          role="tab"
          className={({ isActive }) => `chip${isActive ? ' on' : ''}`}
        >
          {link.label}
        </NavLink>
      ))}
    </div>
  );
}

export function DayRange({
  value,
  onChange,
}: {
  value: number;
  onChange: (days: number) => void;
}) {
  return (
    <div className="chip-row" role="group" aria-label="Date range">
      {[7, 30, 90].map((days) => (
        <button
          key={days}
          type="button"
          className={`chip${value === days ? ' on' : ''}`}
          onClick={() => onChange(days)}
        >
          {days} days
        </button>
      ))}
    </div>
  );
}

export function SparkBars({
  points,
  label,
}: {
  points: Array<{ day: string; value: number }>;
  label: string;
}) {
  if (points.length === 0) return null;
  const max = Math.max(...points.map((p) => p.value), 1);
  return (
    <div className="spark" role="img" aria-label={label}>
      {points.map((point) => (
        <div key={point.day} className="spark-col" title={`${point.day}: ${point.value}`}>
          <div className="spark-bar" style={{ height: `${Math.max(4, (point.value / max) * 100)}%` }} />
        </div>
      ))}
    </div>
  );
}
